import React from "react";

import { connect } from "react-redux";

import { Modal } from "./Modal";
import { closeModal } from "./redux";

import type { Action } from "./redux";
// Your modal render function must accept these props
export type ModalProps = {
  show: boolean;
  onHide: () => Action;
};
type Props = {
  name: string;
  modal?: (arg0: ModalProps) => React.ReactNode;
  children?: React.ReactNode;
  show: boolean;
  closeModal: () => Action;
};

// A ReduxTrigger is a trigger for a modal driven by the Redux store. This means
// you can trigger a modal from elsewhere in the application by using the
// expected name of the modal.
//
// You can pass a modal function which will be passed an onHide method and
// should be used to hide the modal, or you can just include the modal dialog as
// children.
const ReduxTriggerDumb = ({ name: _name, modal, children, show, closeModal, ...rest }: Props) =>
  modal ? modal({ ...rest, show, onHide: closeModal }) : <Modal show={show} onHide={closeModal} children={children} />;

const mapStateToProps = ({ openModal }, { name }) => ({
  show: openModal === name,
});

const mapDispatchToProps = {
  closeModal,
};
const withRedux = connect(mapStateToProps, mapDispatchToProps);
export const ReduxTrigger = withRedux(ReduxTriggerDumb);
